// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".shadow-box.rounded-xl.bg-white.w-full.eventhover[data-v-411fa49a]:hover{-webkit-box-shadow:0 0 7px 0 rgba(170,207,56,.9);box-shadow:0 0 7px 0 rgba(170,207,56,.9);cursor:pointer!important}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
